import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import "../BodyLogos/BodyLogo.css";
export default function BodyLogo() {
  return (
    <Container fluid className="contents">
      <Row className="company-row">
        <Col className="first" md={12} lg={4}>
          Top Companies choose Findemy Business to build in-demand career
          skills.
        </Col>
        <Col md={12} lg={8}>
          <div className="company-logos">
            <img
              src="https://s.udemycdn.com/partner-logos/v4/nasdaq-dark.svg"
              alt="Nasdaq"
            />
            <img
              src="https://s.udemycdn.com/partner-logos/v4/netapp-dark.svg"
              alt="NetApp"
            />
            <img
              src="	https://s.udemycdn.com/partner-logos/v4/volkswagen-dark.svg"
              alt="VolksWagen"
            />
            <img
              src="https://s.udemycdn.com/partner-logos/v4/eventbrite-dark.svg"
              alt="eventbrite"
            />
            <img
              src="	https://s.udemycdn.com/partner-logos/v4/box-dark.svg"
              alt="box-logo"
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
